import { NgModule } from '@angular/core';
import { FiMobileAppHelperService } from '../utilities/fi-services/mobile-app-helper.service';
import { FiBtnMobileAppScanQRCodeDirective } from './fi-btn-mobile-app-scan-qr-code.directive';
import { MobileAppHelperBaseService } from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';

@NgModule({
    declarations: [FiBtnMobileAppScanQRCodeDirective],
    exports: [FiBtnMobileAppScanQRCodeDirective],
    providers: [
        FiMobileAppHelperService,
        {
            provide: MobileAppHelperBaseService,
            useClass: FiMobileAppHelperService,
        },
    ],
})
export class FiMobileAppHelpersModule {}
